<!--
    描述：人员管理--右侧组织架构
    时间：2020-04-22
    Created by yefan
-->
<template>
	<div class="h100">
		<div class="w-table-layout">
			<div class="w-table-content"
				 ref="deptsContent">
				<el-table :data="deptsTreeData.tableData"
						  row-key="id"
						  v-loading="deptsTreeData.loading"
						  ref="deptsTree"
						  :expand-row-keys="deptsTreeData.expandKeys"
						  :height="deptsTreeData.tableH"
						  border
						  highlight-current-row
						  @row-click="rowClick"
						  :tree-props="{ children: 'children' }">
					<el-table-column prop="sname"
									 label="单位名称"
									 show-overflow-tooltip
									 min-width="150"></el-table-column>
					<el-table-column label="操作"
									 align="center"
									 show-overflow-tooltip
									 width="230">
						<template slot-scope="scope">
							<el-button type="success"
									   size="small"
									   round
									   plain
									   class="table-btn"
									   title="新增"
									   :disabled="!roleBtns.includes('user_organize_add')"
									   @click="doClick('add', scope.row)">
								<svg-icon icon-class="form-add"></svg-icon> 新增
							</el-button>
							<el-button type="success"
									   size="small"
									   round
									   plain
									   class="table-btn"
									   title="编辑"
									   :disabled="!roleBtns.includes('user_organize_edit')"
									   @click="doClick('edit', scope.row)">
								<svg-icon icon-class="form-edit"></svg-icon> 编辑
							</el-button>
							<el-button type="danger"
									   size="small"
									   round
									   plain
									   class="table-btn"
									   icon="el-icon-delete"
									   title="删除"
									   :disabled="
                                    (scope.row.children &&
                                        scope.row.children.length > 0) ||
                                    !roleBtns.includes('user_organize_delete')
                                "
									   @click="doClick('delete', scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
                   center
				   destroy-on-close>
			<!-- 弹窗组件 -->
			<addDept ref="addDept"
					 :deptInfo="deptInfo"
					 :mode="mode"
					 v-if="dialogObj.visible"
					 :diaType="diaType"
					 @dialogClose="handleClose"></addDept>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
                           class="btn"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
                           class="btn btn-blue"
						   :loading="btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import addDept from './add_dept_dialog'
import { getSysDept, deleteSysDept } from 'api/modules/sys.js'

export default {
	components: { addDept },
	data() {
		return {
			btnLoading: false,
			dialogObj: {
				title: '',
				visible: false,
				width: '750px',
				mode: 'add',
			},
			deptsTreeData: {
				loading: false,
				tableH: 200,
				tableData: [],
				expandKeys: [],
			},
			diaType: '',
			mode: '',
			deptInfo: { id: '0', sname: '' },
		}
	},
	methods: {
		//新增、修改、删除等操作按钮点击事件
		doClick(type, row) {
			this.mode = type
			this.deptInfo = row
			if (type === 'addUnit') {
				this.dialogObj.title = '新增单位'
				this.dialogObj.visible = true
				this.dialogObj.width = '1000px'
				this.diaType = '0'
			} else if (type === 'add') {
				this.dialogObj.title = '新增部门'
				this.dialogObj.visible = true
				this.diaType = '1'
				this.dialogObj.width = '1000px'
			} else if (type === 'edit') {
				this.dialogObj.title = '编辑'
				this.dialogObj.visible = true
				this.diaType = row.parentId
			} else {
				this.$confirm('确认删除吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					let param = {}
					param.id = row.id
					deleteSysDept(param).then((res) => {
						res.code === 0
							? this.$message.success('删除成功！')
							: this.$message.error(res.msg)
						this.getSysDept()
					})
				})
			}
		},

		//行点击事件
		rowClick(row) {
			this.$emit('deptRowClick', row, this.deptsTreeData.tableData)
		},

		// 清除选中
		clearSelected() {
			this.$refs.deptsTree.setCurrentRow()
		},

		// 初始获取数据
		getSysDept() {
			let param = {}
			getSysDept(param).then((res) => {
				this.deptsTreeData.tableData = res.data
				if (res.data.length > 0) {
					this.deptsTreeData.expandKeys.push(
						res.data[0].id.toString()
					)
				}
			})
		},

		// 关闭弹窗事件
		handleClose() {
			this.dialogObj.visible = false
			this.getSysDept()
		},

		// 确定按钮事件
		doSave() {
			this.$refs.addDept.doSave()
		},
	},
	created() {
		this.getSysDept()
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.deptsTreeData.tableH = this.$refs.deptsContent.offsetHeight
			}, 100)
		})
	},
	// 进入页面缓存
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.deptsTreeData.tableH = this.$refs.deptsContent.offsetHeight
			}, 100)
		})
	},
	computed: {
		...mapState('app', { clientSize: (state) => state.clientSize }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
	watch: {
		clientSize(val) {
			this.deptsTreeData.tableH = this.$refs.deptsContent.offsetHeight
		},
	},
}
</script>
<style lang="less"></style>
